// NPM Imports
import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Loader } from "../../revvComponents";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components Imports
import MetaFieldListAccordion from "./MetaFieldListAccordion";

// Actions Imports

// Internal Imports

// Destructuring

// Declarations

export default function MetaFieldCategories({
  mode,
  metaGroups,
  templatedIdInDoc,
}) {
  // local states
  const [selectedCategory, selectCategory] = useState(null);
  let categories = [
    {
      id: "temp_mf",
      label: "Template Metafields",
      level: "TEMPLATE",
      subHeading: `These metafields are cascaded ${
        mode === "TEMPLATE" ? `to the document` : `from the template`
      }. You can edit the values.`,
      metaFieldItems: [],
    },
    {
      id: "doc_mf",
      label: "Document Metafields",
      level: "DOCUMENT",
      subHeading: "Create additional custom metadata for this document",
      metaFieldItems: [],
    },
  ];
  metaGroups.forEach(metaGroup =>
    categories.forEach(category => {
      if (category.level === metaGroup.level) {
        category.id = metaGroup.id;
        category.name = metaGroup.name;
        category.level = metaGroup.level;
        category.label = `${metaGroup.level} Meta fields`;
        category.subHeading = `${
          metaGroup.level === "TEMPLATE"
            ? `These metafields are cascaded ${
                mode === "TEMPLATE" ? `to the document` : `from the template`
              }. You can edit the values.`
            : `Create additional custom metadata for this document.`
        }`;
        category.metaFieldItems = metaGroup.meta.fields;
      }
    }),
  );
  const _toggleAccordion = newCategory => {
    selectCategory(prevCategory =>
      prevCategory && prevCategory.id === newCategory.id ? null : newCategory,
    );
  };

  useEffect(() => {
    if (categories && categories.length > 0 && categories.length === 1) {
      selectCategory(categories[0]);
    }
  }, []);

  if (mode === "TEMPLATE") {
    categories = categories.filter(categ => categ.level !== "DOCUMENT");
  }

  if (mode === "DOCUMENT" && !templatedIdInDoc) {
    categories = categories.filter(categ => categ.level !== "TEMPLATE");
  }

  // if (categories && categories.length > 0) {
  return (
    categories &&
    categories.length > 0 &&
    categories.map(category => (
      <MetaFieldListAccordion
        totalCategories={categories.length}
        key={category.id}
        heading={category.label}
        subHeading={category.subHeading}
        count={0}
        showAccordionBody={
          selectedCategory && selectedCategory.id === category.id
        }
        selectCategory={() => _toggleAccordion(category)}
        category={selectedCategory}
        metaFieldItems={category.metaFieldItems}
        mode={mode}
      />
    ))
  );
  // }
  // return null;
}
